function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7 8C7 8.15 7.07 8.28 7.17 8.37L11.17 11.87C11.26 11.95 11.37 12 11.5 12C11.78 12 12 11.78 12 11.5L12 4.5C12 4.22 11.78 4 11.5 4C11.37 4 11.26 4.05 11.17 4.13L7.17 7.63C7.07 7.72 7 7.85 7 8Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 8C3 8.15 3.07 8.28 3.17 8.37L7.17 11.87C7.26 11.95 7.37 12 7.5 12C7.78 12 8 11.78 8 11.5L8 4.5C8 4.22 7.78 4 7.5 4C7.37 4 7.26 4.05 7.17 4.13L3.17 7.63C3.07 7.72 3 7.85 3 8Z"
});

var SvgCaretMostLeft = function SvgCaretMostLeft(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCaretMostLeft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/caret-most-left.496e72ed.svg";
export { ForwardRef as ReactComponent };